@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div
  cdkDrag
  class="popup_main_div add_edit_activities_sundry_main"
  cdkDragRootElement=".cdk-overlay-pane"
>
  <h2 cdkDragHandle matDialogTitle class="mat-dialog-header">
    <span>{{ dialogTitle }}</span>
    <button class="close-btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography main">
    <div class="one" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
      <form [formGroup]="activityForm" fxLayout="column" fxFlex="1 0 auto" name="form">
        <mat-checkbox formControlName="HIGHLIGHTITEM">Highlight Item</mat-checkbox>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            appearance="outline"
            fxFlex="33"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.ACTIVITYTYPE),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ACTIVITYTYPE),
            }"
          >
            <mat-label>Activity Type</mat-label>
            <mat-select #value formControlName="ACTIVITYTYPE">
              <mat-option value="Activity">Activity</mat-option>
              <mat-option value="Sundry">Sundry</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            fxFlex="33"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.ACTIVITYID),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ACTIVITYID),
            }"
          >
            <mat-label>Sundry / Activity ID</mat-label>
            <input
              formControlName="ACTIVITYID"
              matInput
              #ACTIVITYID
              (input)="ACTIVITYID.value = $event.target.value.toUpperCase()"
              matTooltip="{{ toolTipList ? toolTipList.ACTIVITYID?.HOVER : '' }}"
            />
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            fxFlex="34"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.DESCRIPTION),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DESCRIPTION),
            }"
          >
            <mat-label>Description</mat-label>
            <input
              formControlName="DESCRIPTION"
              matInput
              matTooltip="{{ toolTipList ? toolTipList.DESCRIPTION?.HOVER : '' }}"
            />
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            appearance="outline"
            fxFlex="50"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.GSTTYPE),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.GSTTYPE),
            }"
          >
            <mat-label>GST Type</mat-label>
            <mat-select #value formControlName="GSTTYPE">
              <mat-option value="GST Exclusive">GST Exclusive</mat-option>
              <mat-option value="GST Inclusive">GST Inclusive</mat-option>
              <mat-option value="GST Free">GST Free</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            fxFlex="50"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.RATEPERUNIT),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.RATEPERUNIT),
            }"
          >
            <mat-label>{{ CurrenctSymbol }} /Unit</mat-label>
            <input
              formControlName="RATEPERUNIT"
              type="text"
              mask="separator.2"
              thousandSeparator=","
              [allowNegativeNumbers]="true"
              decimalMarker="."
              class="sideText"
              matInput
              (focusout)="RatePerUnitVal()"
              [(ngModel)]="RATEPERUNIT"
              [leadZero]="true"
            />
            <!-- <span class="currency_sign" matPrefix>$&nbsp;</span> -->
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            appearance="outline"
            fxFlex="50"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.UNITDESCRIPTIONSINGLE),
              'has-warning': $safeNavigationMigration(
                errorWarningData.Warning?.UNITDESCRIPTIONSINGLE
              ),
            }"
          >
            <mat-label>Unit Desc Single</mat-label>
            <input
              type="text"
              matInput
              formControlName="UNITDESCRIPTIONSINGLE"
              [matAutocomplete]="auto1"
              matTooltip="{{ toolTipList ? toolTipList.UNITDESCRIPTIONSINGLE.HOVER : '' }}"
            />
            <mat-autocomplete #auto1="matAutocomplete">
              <mat-option value="unit">Unit</mat-option>
              <mat-option value="page">Page</mat-option>
              <mat-option value="item">Item</mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            fxFlex="50"
            class="pr-1"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.UNITDESCRIPTIONPLURAL),
              'has-warning': $safeNavigationMigration(
                errorWarningData.Warning?.UNITDESCRIPTIONPLURAL
              ),
            }"
          >
            <mat-label>Unit Desc Plural</mat-label>
            <input
              type="text"
              matInput
              formControlName="UNITDESCRIPTIONPLURAL"
              [matAutocomplete]="auto"
              matTooltip="{{ toolTipList ? toolTipList.UNITDESCRIPTIONPLURAL.HOVER : '' }}"
            />
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option value="units">Units</mat-option>
              <mat-option value="pages">Pages</mat-option>
              <mat-option value="items">Items</mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
  <mat-dialog-actions class="popup_ftr justify-end!">
    <button matButton="filled" class="mat-accent" (click)="saveActivity()" [disabled]="isspiner">
      @if (isspiner) {
        <mat-spinner diameter="24"></mat-spinner>
      }
      {{ dialogTitleBtn }}
    </button>
    <button matButton="tonal" [mat-dialog-close]="false" cdkFocusInitial>Don't Save</button>
  </mat-dialog-actions>
</div>
